module.exports = __webpack_public_path__ + "img/sggl1.8114c7f4.png";